import { render, staticRenderFns } from "./EmailSanitizeList.vue?vue&type=template&id=95d49dc6&"
import script from "./EmailSanitizeList.vue?vue&type=script&lang=ts&"
export * from "./EmailSanitizeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports